<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="200">
				<FormItem label="app类型" prop="appType" class="sj">
					<Select v-model="formValidate.appType" placeholder="请选择类型">
						<Option value="YYAPPANDROID">运营app-安卓</Option>
						<Option value="YYAPPIOS">运营app-IOS</Option>
						<Option value="HOUTAIAPPANDROID">后台管理app-安卓</Option>
						<Option value="HOUTAIAPPIOS">后台管理app-IOS</Option>
					</Select>
				</FormItem>
				<FormItem label="是否必须更新" prop="must" class="sj">
					<Select v-model="formValidate.must" placeholder="请选择是否必须更新">
						<Option value="SHI">必须更新</Option>
						<Option value="FOU">非必须更新</Option>
					</Select>
				</FormItem>
				<FormItem label="更新类型" prop="updateType" class="sj">
					<Select v-model="formValidate.updateType" placeholder="请选择是否必须更新">
						<Option value="REGENGXIN">热更新</Option>
						<Option value="ZHENGBAO">整包升级</Option>
					</Select>
				</FormItem>
				
				<FormItem label="版本类型" prop="official" class="sj">
					<Select v-model="formValidate.official" placeholder="请选择是否必须更新">
						<Option value="shi">正式</Option>
						<Option value="fou">测试</Option>
					</Select>
				</FormItem>
				<FormItem label="版本号" prop="number" class="sj">
					<Input v-model="formValidate.number" placeholder="请输入版本号" ></Input>
				</FormItem>
				<FormItem label="更新内容" prop="remark" class="sj">
					<textarea rows="8" cols="50" v-model="formValidate.remark" placeholder="请输入备注" >请介绍一下你自己</textarea>
				</FormItem>
				<FormItem label="整包名称" prop="url" class="sj">
					<Input v-model="formValidate.url" placeholder="文件名称" disabled="disabled"></Input>
				</FormItem>
				<FormItem label="整包下载地址" prop="url" class="sj">
					<Input v-model="formValidate.url1" placeholder="下载地址" ></Input>
				</FormItem>
				<FormItem label="整包下载地址" v-if="aaa!=''" >
					<div>{{aaa}}</div>
				</FormItem>
				
				<FormItem label="重新上传安装包"  class="sj">
					<File @file="file" :url="url"></File>
				</FormItem>
				<FormItem label="热更新名称" prop="url2" class="sj">
					<Input v-model="formValidate.url2" placeholder="文件名称" disabled="disabled"></Input>
				</FormItem>
				<FormItem label="热更新下载地址" prop="url21" class="sj">
					<Input v-model="formValidate.url21" placeholder="下载地址" ></Input>
				</FormItem>
				<FormItem label="热更新下载地址" v-if="aaa2!=''" >
					<div>{{aaa2}}</div>
				</FormItem>
				<FormItem label="重新上传安装包"  class="sj">
					<File @file="file2" :url="url"></File>
				</FormItem>
				
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	import File from '@/components/comm/file.vue'
	export default {
		data() {
			return {
				aaa:'',
				aaa2:'',
				url:'',
				formValidate: {
					appType: '',
					must: '',
					number: '',
					remark: '',
					url:'',
					updateType:'',
					official:''
				},
				ruleValidate: {
					official: [{
						required: true,
						message: 'app类型不能为空！！！',
						trigger: 'blur'
					}],
					appType: [{
						required: true,
						message: 'app类型不能为空！！！',
						trigger: 'blur'
					}],
					must: [{
						required: true,
						message: '是否必须更新不能为空！！！',
						trigger: 'blur'
					}],
					number: [{
						required: true,
						message: '版本号不能为空！！！',
						trigger: 'blur'
					}],
					remark: [{
						required: true,
						message: '更新内容不能为空！！！',
						trigger: 'blur'
					}],
					
					updateType: [{
						required: true,
						message: '更新类型不能为空！！！',
						trigger: 'blur'
					}]
				
				}

			}
		},
		components:{
			File
		},

		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			
			file(file){
				let _this=this
				_this.formValidate.url=file.name
				_this.aaa=file.url
			},
			file2(file){
				let _this=this
				_this.formValidate.url2=file.name
				_this.aaa2=file.url
			},
			handleSubmit(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {
						let _this=this
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/app/vesions/update',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('修改成功!');
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })

					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}
		},
		created() {
			let _this=this
			let id=this.$route.query.id
			_this.url=http.url+"/file/app"
			this.formValidate.id=id
			http.http({
			    //这里是你自己的请求方式、url和data参数
			    method: 'post',
			    url: http.url + '/app/vesions/get',
			    data: {id:id},
				_this: _this,
				success: function(data) {
					_this.formValidate=data.platVersions
				}
			    //假设后台需要的是表单数据这里你就可以更改
			  })
			
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 600px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/versions/update.vue